import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./features/authSlice";
import userSlice from "./features/userSlice";
import paymentSlice from "./features/paymentSlice";
import userListSlice from "./features/userListSlice";
import { paymentFormData } from "./reducers/formReducers";
import paymentListSlice from "./features/paymentListSlice";
import userForm from "./actions/userForm";
import { userFormCreate } from "./reducers/userFormReducer";

export const storage = configureStore({
    reducer: {
        credentials: authSlice,
        userCreate: userSlice,
        verifyPayment: paymentSlice,
        userList: userListSlice,
        paymentForm: paymentFormData,
        paymentList: paymentListSlice,
        userForm: userFormCreate
    }
})

export type RootState = ReturnType<typeof storage.getState>
export type AppDispatch = typeof storage.dispatch